// src/galaxy-note.tsx
import * as React from "react";
var GalaxyNote8 = React.forwardRef(
  function GalaxyNote82(props, ref) {
    return /* @__PURE__ */ React.createElement("div", {
      className: props.className,
      ref
    }, /* @__PURE__ */ React.createElement("div", {
      className: "marvel-device note8"
    }, /* @__PURE__ */ React.createElement("div", {
      className: "inner"
    }), /* @__PURE__ */ React.createElement("div", {
      className: "overflow"
    }, /* @__PURE__ */ React.createElement("div", {
      className: "shadow"
    })), /* @__PURE__ */ React.createElement("div", {
      className: "speaker"
    }), /* @__PURE__ */ React.createElement("div", {
      className: "sensors"
    }), /* @__PURE__ */ React.createElement("div", {
      className: "more-sensors"
    }), /* @__PURE__ */ React.createElement("div", {
      className: "sleep"
    }), /* @__PURE__ */ React.createElement("div", {
      className: "volume"
    }), /* @__PURE__ */ React.createElement("div", {
      className: "camera"
    }), /* @__PURE__ */ React.createElement("div", {
      className: "screen"
    }, props.children)));
  }
);
var GalaxyNote10 = React.forwardRef(
  function GalaxyNote102(props, ref) {
    return /* @__PURE__ */ React.createElement("div", {
      className: props.className,
      ref
    }, /* @__PURE__ */ React.createElement("div", {
      className: "marvel-device note10"
    }, /* @__PURE__ */ React.createElement("div", {
      className: "inner"
    }), /* @__PURE__ */ React.createElement("div", {
      className: "overflow"
    }, /* @__PURE__ */ React.createElement("div", {
      className: "shadow"
    })), /* @__PURE__ */ React.createElement("div", {
      className: "speaker"
    }), /* @__PURE__ */ React.createElement("div", {
      className: "sensors"
    }), /* @__PURE__ */ React.createElement("div", {
      className: "more-sensors"
    }), /* @__PURE__ */ React.createElement("div", {
      className: "sleep"
    }), /* @__PURE__ */ React.createElement("div", {
      className: "volume"
    }), /* @__PURE__ */ React.createElement("div", {
      className: "camera"
    }), /* @__PURE__ */ React.createElement("div", {
      className: "screen"
    }, props.children)));
  }
);

// src/ipad.tsx
import * as React2 from "react";
var IPad = React2.forwardRef(function IPad2(props, ref) {
  return /* @__PURE__ */ React2.createElement("div", {
    className: props.className,
    ref
  }, /* @__PURE__ */ React2.createElement("div", {
    className: "marvel-device ipad silver"
  }, /* @__PURE__ */ React2.createElement("div", {
    className: "camera"
  }), /* @__PURE__ */ React2.createElement("div", {
    className: "screen"
  }, props.children), /* @__PURE__ */ React2.createElement("div", {
    className: "home"
  })));
});
var IPadPro = React2.forwardRef(
  function IPadPro2(props, ref) {
    return /* @__PURE__ */ React2.createElement("div", {
      className: props.className,
      ref
    }, /* @__PURE__ */ React2.createElement("div", {
      className: "marvel-device ipad-pro silver"
    }, /* @__PURE__ */ React2.createElement("div", {
      className: "camera"
    }), /* @__PURE__ */ React2.createElement("div", {
      className: "screen"
    }, props.children), /* @__PURE__ */ React2.createElement("div", {
      className: "home"
    })));
  }
);
var IPadMini = React2.forwardRef(
  function IPadMini2(props, ref) {
    return /* @__PURE__ */ React2.createElement("div", {
      className: props.className,
      ref
    }, /* @__PURE__ */ React2.createElement("div", {
      className: "marvel-device ipad-mini silver"
    }, /* @__PURE__ */ React2.createElement("div", {
      className: "camera"
    }), /* @__PURE__ */ React2.createElement("div", {
      className: "screen"
    }, props.children), /* @__PURE__ */ React2.createElement("div", {
      className: "home"
    })));
  }
);

// src/iphone.tsx
import { ChartBarIcon, VolumeOffIcon, WifiIcon } from "@heroicons/react/solid";
import * as React3 from "react";
var Time = () => {
  const [time, setTime] = React3.useState("");
  React3.useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      setTime(now.toLocaleTimeString("it-IT").slice(0, 5));
    };
    const timerId = window.setInterval(updateTime, 1e3);
    return () => window.clearInterval(timerId);
  }, []);
  return time ? /* @__PURE__ */ React3.createElement("time", {
    dateTime: time
  }, time) : null;
};
var IPhoneX = React3.forwardRef(
  function IPhoneX2(props, ref) {
    return /* @__PURE__ */ React3.createElement("div", {
      className: props.className,
      ref
    }, /* @__PURE__ */ React3.createElement("div", {
      className: "marvel-device iphone-x"
    }, /* @__PURE__ */ React3.createElement("div", {
      className: "notch"
    }, /* @__PURE__ */ React3.createElement("div", {
      className: "camera"
    }), /* @__PURE__ */ React3.createElement("div", {
      className: "speaker"
    })), /* @__PURE__ */ React3.createElement("div", {
      className: "top-bar"
    }), /* @__PURE__ */ React3.createElement("div", {
      className: "sleep"
    }), /* @__PURE__ */ React3.createElement("div", {
      className: "bottom-bar"
    }), /* @__PURE__ */ React3.createElement("div", {
      className: "volume"
    }), /* @__PURE__ */ React3.createElement("div", {
      className: "overflow"
    }, /* @__PURE__ */ React3.createElement("div", {
      className: "shadow shadow--tr"
    }), /* @__PURE__ */ React3.createElement("div", {
      className: "shadow shadow--tl"
    }), /* @__PURE__ */ React3.createElement("div", {
      className: "shadow shadow--br"
    }), /* @__PURE__ */ React3.createElement("div", {
      className: "shadow shadow--bl"
    })), /* @__PURE__ */ React3.createElement("div", {
      className: "inner-shadow"
    }), /* @__PURE__ */ React3.createElement("div", {
      className: "screen"
    }, /* @__PURE__ */ React3.createElement("div", {
      className: "status-bar"
    }, /* @__PURE__ */ React3.createElement("div", {
      className: "status-bar-time"
    }, /* @__PURE__ */ React3.createElement(Time, null)), /* @__PURE__ */ React3.createElement("div", {
      className: "status-bar-notification"
    }, /* @__PURE__ */ React3.createElement(ChartBarIcon, {
      width: 16,
      height: 16
    }), /* @__PURE__ */ React3.createElement(WifiIcon, {
      width: 16,
      height: 16
    }), /* @__PURE__ */ React3.createElement(VolumeOffIcon, {
      width: 16,
      height: 16
    }))), /* @__PURE__ */ React3.createElement("div", {
      className: "screen-content"
    }, props.children))));
  }
);
var IPhone8 = React3.forwardRef(
  function IPhone82(props, ref) {
    return /* @__PURE__ */ React3.createElement("div", {
      className: props.className,
      ref
    }, /* @__PURE__ */ React3.createElement("div", {
      className: "marvel-device iphone8 black"
    }, /* @__PURE__ */ React3.createElement("div", {
      className: "topbar"
    }), /* @__PURE__ */ React3.createElement("div", {
      className: "sleep"
    }), /* @__PURE__ */ React3.createElement("div", {
      className: "volume"
    }), /* @__PURE__ */ React3.createElement("div", {
      className: "camera"
    }), /* @__PURE__ */ React3.createElement("div", {
      className: "speaker"
    }), /* @__PURE__ */ React3.createElement("div", {
      className: "screen"
    }, props.children), /* @__PURE__ */ React3.createElement("div", {
      className: "home"
    }), /* @__PURE__ */ React3.createElement("div", {
      className: "bottom-bar"
    })));
  }
);

// src/macbook.tsx
import * as React4 from "react";
var MacbookAir = React4.forwardRef(
  function MacbookAir2(props, ref) {
    return /* @__PURE__ */ React4.createElement("div", {
      className: props.className,
      ref
    }, /* @__PURE__ */ React4.createElement("div", {
      className: "laptop-wrapper"
    }, /* @__PURE__ */ React4.createElement("div", {
      className: "marvel-device macbook-air"
    }, /* @__PURE__ */ React4.createElement("div", {
      className: "top-bar"
    }), /* @__PURE__ */ React4.createElement("div", {
      className: "camera"
    }), /* @__PURE__ */ React4.createElement("div", {
      className: "screen"
    }, props.children), /* @__PURE__ */ React4.createElement("div", {
      className: "bottom-bar"
    }))));
  }
);
var MacbookPro = React4.forwardRef(
  function MacbookPro2(props, ref) {
    return /* @__PURE__ */ React4.createElement("div", {
      className: props.className,
      ref
    }, /* @__PURE__ */ React4.createElement("div", {
      className: "laptop-wrapper"
    }, /* @__PURE__ */ React4.createElement("div", {
      className: "marvel-device macbook"
    }, /* @__PURE__ */ React4.createElement("div", {
      className: "top-bar"
    }), /* @__PURE__ */ React4.createElement("div", {
      className: "camera"
    }), /* @__PURE__ */ React4.createElement("div", {
      className: "screen"
    }, props.children), /* @__PURE__ */ React4.createElement("div", {
      className: "bottom-bar"
    }))));
  }
);
export {
  GalaxyNote10,
  GalaxyNote8,
  IPad,
  IPadMini,
  IPadPro,
  IPhone8,
  IPhoneX,
  MacbookAir,
  MacbookPro
};
//# sourceMappingURL=index.js.map